var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/sections/product-recommendations.js
var _isLoaded, _loadRecommendations, loadRecommendations_fn;
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _loadRecommendations);
    __privateAdd(this, _isLoaded, false);
    this.sectionId = this.dataset.sectionId;
    this.placementId = this.dataset.placementId;
  }

  connectedCallback() {
    __privateMethod(this, _loadRecommendations, loadRecommendations_fn).call(this);
    this.init();
  }

init() {
  const sectionId = this.sectionId.includes("cart-drawer") ? 'cart-drawer-section' : this.sectionId;;
  const placementId = this.placementId;
  const isNostoWithSize = this.hasAttribute("nosto-with-size");
  const sectionToRender = isNostoWithSize ? "product-card-with-size" : "product-card";
  const container = document.querySelector(`product-recommendations[data-section-id="${sectionId}"] .product-list`);

  nostojs(async (api) => {
    try {
      // Request recommendations in JSON mode
      const response = await api
        .createRecommendationRequest({ includeTagging: true })
        .setResponseMode("JSON_ORIGINAL")
        .setElements([placementId])
        .load();

      const recommendation = response.recommendations[placementId];
      
      // If no recommendations, remove the section
      if (!recommendation || !recommendation.products || recommendation.products.length === 0) {
        const section = document.querySelector(`#shopify-section-${sectionId}`);
        if (section) section.remove();
        return;
      }

      // Fetch Shopify product cards for each recommended product
      await this.renderProducts(recommendation.products, container, sectionToRender);

      // Register parameterless attribution - this is the key line!
      api.attributeProductClicksInCampaign(container, recommendation);

      // Handle add to cart for Nosto tracking
      this.addEventListener("variant:add", (event) => {
        if (event.detail.isNostoWithSize) {
          const product_id = event.detail.items[0]?.product_id;
          api.recommendedProductAddedToCart(product_id, placementId);
        }
      });

    } catch (error) {
      console.error("Failed to load Nosto recommendations:", error);
      const section = document.querySelector(`#shopify-section-${sectionId}`);
      if (section) section.remove();
    }
  });
}

async renderProducts(products, container, sectionToRender) {
  const baseUrl = window.Shopify.routes.root;
  
  // Fetch Shopify sections for each product
  const promises = products.map((product) => {
    // Extract handle from Nosto URL and rebuild with current locale/market
    const urlParts = product.url.split('/');
    const handle = urlParts[urlParts.length - 1];
    const productUrl = `${window.location.origin}${baseUrl}products/${handle}`;
    return fetch(`${productUrl}?sections=${sectionToRender}`)
      .then(res => res.json())
      .catch(err => {
        console.error(`Failed to fetch product ${product.product_id}:`, err);
        return null;
      });
  });

  const results = await Promise.all(promises);
  
  // Filter valid products
  const validProducts = results.filter(productData => {
    if (!productData) return false;
    const productCard = productData[sectionToRender];

    return productCard && 
           !productCard.includes('data-product-id=""') &&
           productCard.includes('product-card__image');
  });

  // Render products
  container.innerHTML = validProducts.map(r => r[sectionToRender]).join("");

  // Process cards (swatches, modals, etc.)
  const cards = container.querySelectorAll('product-card, .product-card');
  
  cards.forEach((card) => {
    card.classList.add('nosto-recommendation');

    // Handle swatch radios
    const swatchRadio = card.querySelectorAll('input[type=radio]');
    swatchRadio.forEach((radio) => {
      if (radio.id) {
        const newId = radio.id + "-nosto";
        radio.id = newId;
        const label = card.querySelector(`label[for="${radio.id.replace("-nosto", "")}"]`);
        if (label) {
          label.setAttribute("for", newId);
        }
      }
    });

    // Handle quick buy modal
    const quickAddButton = card.querySelector(".product-card__quick-add-button");
    const quickBuyModal = card.querySelector("quick-buy-modal");
    if (quickAddButton && quickBuyModal) {
      const ariaControls = quickAddButton.getAttribute('aria-controls');
      if (ariaControls) {
        quickAddButton.setAttribute('aria-controls', ariaControls + '-nosto-recommendation');
      }
      const modalId = quickBuyModal.id;
      if (modalId) {
        quickBuyModal.id = modalId + '-nosto-recommendation';
      }
    }

    card.addEventListener('click', (e) => {
      if (e.target.closest('.product-card__quick-add-button')) {
        nostojs(async (api) => {

            const response = await api
              .createRecommendationRequest({ includeTagging: true })
              .setResponseMode("JSON_ORIGINAL")
              .setElements([this.placementId])
              .load();

            const recommendation = response.recommendations[this.placementId];
              if(recommendation) {
                api.attributeProductClicksInCampaign(container, recommendation);
              }
            });
         }
        });
      
  });

  document.dispatchEvent(new CustomEvent("recommendation-rendered"));
}
};


_isLoaded = new WeakMap();
_loadRecommendations = new WeakSet();
loadRecommendations_fn = async function() {
  if (__privateGet(this, _isLoaded)) {
    return;
  }
  __privateSet(this, _isLoaded, true);

  if(this.hasAttribute("product") && !this.hasAttribute("is-nosto-recommendation")){
    const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${extractSectionId(section)}&intent=${intent}`, response = await fetch(url, { priority: intent === "related" ? "low" : "auto" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("product-recommendations");
    if (productRecommendationsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
      this.hidden = false;
    } else {
      this.remove();
    }
  }

};
if (!window.customElements.get("product-recommendations")) {
  window.customElements.define("product-recommendations", ProductRecommendations);
}

const placementID = "nosto-placement";
if (typeof nostojs === "function") {
  nostojs(async (api) => {
    try {
      const response = await api
        .createRecommendationRequest({ includeTagging: true })
        .setResponseMode("JSON_ORIGINAL")
        .setElements([placementID])
        .load();

      console.log("Nosto response:", response);
    } catch (err) {
      console.error("Failed to load Nosto recommendations:", err);
    }
  });
} else {
  console.error("Nosto script not loaded or nostojs is undefined");
}
